import React from "react";
import {
  useReactTable,
  getCoreRowModel,
  flexRender,
  getPaginationRowModel,
  getSortedRowModel,
  getFilteredRowModel,
} from "@tanstack/react-table";
import {
  LuCheck,
  LuTrash,
  LuSearch,
  LuBadgeDollarSign,
  LuDownload,
  LuAlertCircle,
} from "react-icons/lu";
import axios from "../../axiosIn";
import { variables } from "../../Variables";
import { DateTime } from "luxon";
import { Image } from "react-bootstrap";
import { useState } from "react";
import { LuArrowLeftToLine } from "react-icons/lu";
import { LuArrowLeft } from "react-icons/lu";
import { LuArrowRight } from "react-icons/lu";
import { LuArrowRightToLine } from "react-icons/lu";
import { toaster, Message, Modal, Button } from "rsuite";

const Datatable = ({ rows, filtering, estatusInsc }) => {
  const data = rows;
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [ID, setID] = React.useState(0);
  const [estatus, setEstatus] = React.useState("");
  const [estatusIncrips, setEstatusInscrip] = useState(estatusInsc);
  const [fileImage, setFileImage] = React.useState("");
  const [modalTitle, setModalTitle] = React.useState("Foto");
  const [curp, setCurp] = React.useState("");

  
  const setDataSelected = async (id, estatus) => {
    showImage(id, estatus);
  };

  const toast = (msg, type = "info") => {
    toaster.push(
      <Message showIcon type={type} closable>
        <strong>{type}!</strong>
        &nbsp; {msg}
      </Message>,
      { duration: 5000, placement: "topCenter" }
    );
  };

  const download = async (id) => {
    var url = `${variables.API_URL}Registro/download/${id}`;
    await axios
      .get(url)
      .then((response) => {
        var element = document.createElement("a");
        element.href = url;
        element.download = "Comprobante.jpg";
        element.click();
      })
      .catch((err) => console.error(err));
  };

  const showImage = async (id, estatus) => {
    var url = `${variables.API_URL}Registro/ValidaDirectorio/${id}`;
    await axios
      .get(url)
      .then((response) => {
        if (response.data != "0") {
          var file = response.data.foto;
          
          setID(id);
          setEstatus(estatus);
          setModalTitle("Foto del participante");
          setCurp(response.data.curp);
          setFileImage(file);
          handleOpen();
        } else {
          toast(
            "El directorio no existe, conctacte al Administrador del sistema",
            "warning"
          );
        }
      })
      .catch((err) => console.error(err));
  };

  const columns = [
    {
      header: "#",
      accessorKey: "id",
    },
    {
      header: "Nombre",
      accessorKey: "nombre",
    },
    {
      header: "Equipo",
      accessorKey: "equipo",
    },
    {
      header: "Con Playera",
      accessorKey: "conPlayera",
      cell: (info) => (
        <span style={{ textAlign: "center" }}>{info.renderValue()}</span>
      ),
    },
    {
      header: "Talla",
      accessorKey: "talla",
      cell: (info) => (
        <span style={{ textAlign: "center" }}>{info.renderValue()}</span>
      ),
    },
    {
      header: "Categoría",
      accessorKey: "categoria",
    },
    {
      header: "Clave",
      accessorKey: "clave",
      cell: (info) => (
        <span style={{ textAlign: "center" }}>{info.renderValue()}</span>
      ),
    },
    {
      header: "Procedencia",
      accessorKey: "procedencia",
    },
    {
      header: "Foto",
      accessorKey: "foto",
      cell: ({ row }) => (
        <div style={{ textAlign: "center" }}>
          {estatusInsc.toUpperCase() === "SIN VALIDAR" ? (
            ""
          ) : (
            <>
              
              <a
                onClick={() =>
                  setDataSelected(
                    row.getValue("id"),
                    "VALIDADO"
                  )
                }
                style={{ color: "blue", cursor: "pointer" }}
              >
                <LuSearch />
              </a>
            </>
          )}
        </div>
      ),
    },
    {
      header: "Estatus",
      accessorKey: "statusInscrip",
    },
  ];

  const [sorting, setSorting] = useState([]);
  const [setFiltering] = useState("");

  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    state: {
      sorting: sorting,
      globalFilter: filtering,
    },
    onSortingChange: setSorting,
    onGlobalFilterChange: setFiltering,
  });

  return (
    <>
      <div className="w3-container w3-responsive">
        <div className="row mb-2">
          <br></br>
          <table className="w3-table-all w3-hoverable w3-card-4">
            {table.getHeaderGroups().map((headerGroup) => (
              <tr
                key={headerGroup.id}
                className="w3-light-gray"
                style={{ cursor: "pointer" }}
              >
                {headerGroup.headers.map((header) => (
                  <th
                    key={header.id}
                    onClick={header.column.getToggleSortingHandler()}
                  >
                    {flexRender(
                      header.column.columnDef.header,
                      header.getContext()
                    )}
                    {
                      { asc: "⬆️", desc: "⬇️" }[
                        header.column.getIsSorted() ?? null
                      ]
                    }
                  </th>
                ))}
              </tr>
            ))}
            <tbody style={{ color: "black" }}>
              {table.getRowModel().rows.length === 0 ? (
                <tr>
                  <td colSpan={12} style={{ textAlign: "center" }}>
                    No se encontrarón registros
                  </td>
                </tr>
              ) : (
                table.getRowModel().rows.map((row) => (
                  <tr key={row.id}>
                    {row.getVisibleCells().map((cell) => (
                      <td key={cell.id}>
                        {flexRender(
                          cell.column.columnDef.cell,
                          cell.getContext()
                        )}
                      </td>
                    ))}
                  </tr>
                ))
              )}
            </tbody>
          </table>
          <br></br>
          <div className="float-end">
            <button
              onClick={() => table.setPageIndex(0)}
              className="btn btn-secondary-outline"
              style={{ fontSize: "18px" }}
            >
              <LuArrowLeftToLine />
            </button>
            <button
              disabled={!table.getCanPreviousPage()}
              onClick={() => table.previousPage()}
              className="btn btn-secondary-outline"
              style={{ fontSize: "18px" }}
            >
              <LuArrowLeft />
            </button>
            <button
              disabled={!table.getCanNextPage()}
              onClick={() => table.nextPage()}
              className="btn btn-secondary-outline"
              style={{ fontSize: "18px" }}
            >
              <LuArrowRight />
            </button>
            <button
              onClick={() => table.setPageIndex(table.getPageCount() - 1)}
              className="btn btn-secondary-outline"
              style={{ fontSize: "18px" }}
            >
              <LuArrowRightToLine />
            </button>
          </div>
          <br></br>
        </div>
      </div>

      <Modal
        backdrop={true}
        keyboard={true}
        open={open}
        size="sm"
        onClose={handleClose}
      >
        <Modal.Header>
          <Modal.Title>{modalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Image
            src={`${variables.PHOTO_URL}/${curp}/${fileImage}`}
            width={"320px"}
            height={"450px"}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            appearance="ghost"
            className="w-100"
            color="blue"
            onClick={() => download(ID)}
          >
            Descargar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Datatable;
